export const useHeader = (state: boolean) => {
    const { $gsap: gsap, $ScrollTrigger: ScrollTrigger } = useNuxtApp();

    const header = document.querySelector<HTMLElement>('.elle-header');
    const footer = document.querySelector<HTMLElement>('.elle-footer');
    const hero = document.querySelector('[data-is-hero]');
    document.body.dataset.pageEnd = 'false';

    if (state && header && footer) {
        gsap.to(header, {
            duration: 0.35,
            delay: 0.2,
            opacity: 1,
            ease: 'power4.in'
        });

        const headerHeight = `${header.scrollHeight / 16}rem`;
        const footerHeight = `${footer.scrollHeight / 16}rem`;

        if (hero) {
            ScrollTrigger.create({
                trigger: hero,
                invalidateOnRefresh: true,
                start: () => `0% ${headerHeight}`,
                end: () => `100% ${headerHeight}`,
                onEnter: () => (document.body.dataset.scrolledHero = 'true'),
                onEnterBack: () => (document.body.dataset.scrolledHero = 'true'),
                onLeave: () => (document.body.dataset.scrolledHero = 'false'),
                onLeaveBack: () => (document.body.dataset.scrolledHero = 'false')
            });
        }

        ScrollTrigger.create({
            trigger: footer,
            invalidateOnRefresh: true,
            start: () => `0% ${footerHeight}`,
            end: () => `100% ${footerHeight}`,
            onEnter: () => (document.body.dataset.pageEnd = 'true'),
            onEnterBack: () => (document.body.dataset.pagEend = 'true'),
            onLeave: () => (document.body.dataset.pageEnd = 'false'),
            onLeaveBack: () => (document.body.dataset.pageEnd = 'false')
        });
    } else if (header) {
        gsap.set(header, {
            duration: 0.2,
            ease: 'elastic.out',
            opacity: 0
        });
    }
};
